var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.4893,
    y: 47.998,
    width: 2.80576,
    height: 2.80576,
    fill: "#00C7FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_240_7597",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -10,
    width: 60,
    height: 61
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1772,
    y: -9.06445,
    width: 42.1084,
    height: 42.6336,
    transform: "rotate(45 30.1772 -9.06445)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_240_7597)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.9999,
    cy: 50.3719,
    r: 39.9281,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 29.9997,
    cy: 49.9402,
    r: 35.8273,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 30.0001,
    cy: 49.5084,
    r: 31.7266,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 30,
    cy: 49.0771,
    r: 27.6259,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 29.9999,
    cy: 49.7245,
    r: 24.6043,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 29.9997,
    cy: 49.7243,
    r: 20.9353,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 30.0001,
    cy: 49.94,
    r: 17.2662,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 30.2158,
    cy: 51.0195,
    r: 14.4604,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30.1078,
    cy: 50.4799,
    r: 10.036,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 29.9998,
    cy: 50.5876,
    r: 6.47482,
    stroke: "#00C7FD",
    strokeWidth: 2.15827
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.fb2f9e9467275af51b5243756e434d39.svg";
export { ForwardRef as ReactComponent };